module.exports = __webpack_public_path__ + "img/facebook.7f59aa78.svg";